import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import UserService from '../services/UserService';
import { fetchRxntSettings } from './RxntSlice';
import { fetchRxntPendingRowsAggregated } from '../utils/rxntPendingNotificationUtils';

export const fetchNotificationStatus = createAsyncThunk(
  'api/fetchNotificationStatus',
  async () => {
    const response = await UserService.getUsersNotifications();
    return response; 
  }
);

/** Loads RXNT settings then counts deduped pending RXNT rows (for header badge). */
export const fetchRxntPendingNotificationCount = createAsyncThunk(
  'notification/fetchRxntPendingNotificationCount',
  async (_, { dispatch, getState }) => {
    try {
      await dispatch(fetchRxntSettings()).unwrap();
    } catch {
      return 0;
    }
    const { rxnt } = getState();
    if (!rxnt.settings.rx_enabled) return 0;
    try {
      const { rows } = await fetchRxntPendingRowsAggregated();
      return rows.length;
    } catch {
      return 0;
    }
  }
);

const NotificationSlice = createSlice({
  name: 'api',
  initialState: {
    data: { notification: [], pendingCount: 0, rxntPendingCount: 0 },
    loading: false,
    error: null,
  },
  reducers: {
    setRxntPendingNotificationCount: (state, action) => {
      const n = action.payload;
      state.data.rxntPendingCount = typeof n === 'number' && !Number.isNaN(n) ? n : 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotificationStatus.fulfilled, (state, action) => {
        state.loading = false;
        const { notifications, pendingCount } = action.payload;        
        state.data.notification = notifications || [];
        state.data.pendingCount = pendingCount || 0;
      })
      .addCase(fetchNotificationStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRxntPendingNotificationCount.fulfilled, (state, action) => {
        if (typeof action.payload === 'number') {
          state.data.rxntPendingCount = action.payload;
        }
      });
  },
});

export const { setRxntPendingNotificationCount } = NotificationSlice.actions;

export const notificationStatus = (state) => state.notification.data;
// export const selectApiLoading = (state) => state.api.loading;
// export const selectApiError = (state) => state.api.error;

export default NotificationSlice.reducer;
